/**
 * @generated SignedSource<<7fa7496aebf947dcf17dfeae72102f68>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "where"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "where",
            "variableName": "where"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ScheduleShiftVacancyNotifyModalForm_queryQuery",
            "selections": [
                {
                    "args": (v1 /*: any*/),
                    "kind": "FragmentSpread",
                    "name": "ScheduleShiftVacancyNotifyModalForm_query"
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ScheduleShiftVacancyNotifyModalForm_queryQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "UserConnection",
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "fullName",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "583c43216be60d3983a904242fcac5ed",
            "id": null,
            "metadata": {},
            "name": "ScheduleShiftVacancyNotifyModalForm_queryQuery",
            "operationKind": "query",
            "text": "query ScheduleShiftVacancyNotifyModalForm_queryQuery(\n  $where: UserFilterInput\n) {\n  ...ScheduleShiftVacancyNotifyModalForm_query_3FC4Qo\n}\n\nfragment ScheduleShiftVacancyNotifyModalForm_query_3FC4Qo on Query {\n  users(where: $where) {\n    nodes {\n      id\n      fullName\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "d56d92b87f24a0fc0de6dda23e730a60";
export default node;
